export default {"src":"/_next/static/media/logo_with_text.90018d95.svg","height":382,"width":922};